<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :visible="open"
    @close="onCloseConfirm(() => (open = false))"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules" :colon="false">
      <!-- 基础信息 -->
      <a-form-model-item label="分类名称" prop="categoryName">
        <a-input v-model.trim="form.categoryName" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>

      <!-- 视觉素材 -->
      <a-form-model-item label="类目图标" prop="icon">
        <file-upload
          type="image"
          :defaultList="iconList"
          :file="form.icon"
          @input="getImg($event, 'icon')"
          :count="1"
          autoCropWidth="80"
          autoCropHeight="80"
          :isUpload="false"
          accept=".jpg,.jpeg,.png,.webp"
          :size="2"
        />
      </a-form-model-item>

      <a-form-model-item label="类目图片" prop="pic">
        <file-upload
          type="image"
          :defaultList="picList"
          :file="form.pic"
          @input="getImg($event, 'pic')"
          :count="1"
          autoCropWidth="80"
          autoCropHeight="80"
          :isUpload="false"
          accept=".jpg,.jpeg,.png,.webp"
          :size="2"
        />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group button-style="solid" v-model="form.status">
          <a-radio-button :value="1">启用</a-radio-button>
          <a-radio-button :value="0">禁用</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <!-- 推荐设置 -->
      <a-form-model-item label="角标是否推荐" prop="subscriptRecommend">
        <a-radio-group button-style="solid" v-model="form.subscriptRecommend">
          <a-radio-button :value="1">是</a-radio-button>
          <a-radio-button :value="0">否</a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="角标推荐内容" prop="subscriptRecommendVal" v-if="form.subscriptRecommend == 1">
        <a-input v-model="form.subscriptRecommendVal" placeholder="请输入" :maxLength="20" />
      </a-form-model-item>

      <!-- 运营信息 -->
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model.trim="form.remark" placeholder="请输入" :maxLength="150" :rows="2" />
      </a-form-model-item>

      <!-- 系统信息 -->
      <a-form-model-item label="排序" prop="sort">
        <a-input-number
          v-model="form.sort"
          :min="0"
          :max="9999"
          :precision="0"
          placeholder="请输入"
          style="width: 100%"
        />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getObj, addObj, putObj } from '@/api/maintenance/classification/index.js'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: { type: Array, required: true },
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      open: false,
      showLoading: false,
      iconList: [],
      picList: [],
      recHistory: ['HOT', 'NEW', '爆款', '限时'], // 历史推荐词
      form: {
        id: undefined,
        categoryName: undefined,
        pic: undefined,
        icon: undefined,
        remark: undefined,
        parentId: 0,
        status: 1,
        sort: 99,
        subscriptRecommend: 1,
        subscriptRecommendVal: '',
      },
      rules: {
        categoryName: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传类目图片', trigger: 'change' }],
        icon: [{ required: true, message: '请上传类目图标', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        subscriptRecommendVal: [{ required: true, message: '请输入推荐内容', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        subscriptRecommend: [{ required: true, message: '请选择是否推荐', trigger: 'change' }],
      },
    }
  },
  methods: {
    handleClose() {
      this.$confirm({
        title: '是否确认关闭并清空数据？',
        onOk: () => {
          this.reset()
          this.open = false
        },
      })
    },
    cancel() {
      this.onCloseConfirm(() => (this.open = false))
    },
    onCloseConfirm(okFn) {
      this.$confirm({
        title: '关闭后已填数据将被清空，是否继续？',
        onOk: okFn,
        onCancel: () => {},
      })
    },
    reset() {
      this.form = this.$options.data().form
      this.iconList = []
      this.picList = []
    },
    getImg(url, field) {
      this.form[field] = url
      this.$refs.form.clearValidate(field)
    },
    handleAdd(row) {
      this.reset()
      this.open = true
      if (row) {
        this.form.parentId = row.id
        this.formTitle = row.parentId == 0 ? '添加二级分类' : '添加三级分类'
      } else {
        this.form.parentId = 0
        this.formTitle = '添加一级分类'
      }
    },
    handleUpdate(row, ids) {
      this.reset()
      const id = row ? row.id : ids
      getObj(id).then((res) => {
        this.form = res.data
        this.form.parentId = row ? row.parentId : 0
        this.iconList = this.form.icon ? [this.form.icon] : []
        this.picList = this.form.pic ? [this.form.pic] : []
        this.formTitle = '修改分类'
        this.open = true
      })
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submitLoading = true
        const api = this.form.id ? putObj : addObj
        api(this.form)
          .then(() => {
            this.$message.success(this.form.id ? '修改成功' : '新增成功')
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
  },
}
</script>
